import { takeEvery, put, call } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import { Collection, ScreenSection } from '../api/types'
import { MapRouteRequestParams, fetchMapRoute, LoadMapRouteFromNetworkResult } from '../api/actions'
import { loadedMapRouteFromDisk, loadMapRoutes, LoadMapRoutesParams } from './actions'
import { store } from '../root/index'
import { getConfiguration } from '../configuration/index'
import { MapRoute } from 'mytours-read-api-typescript'

function* handleLoadMapRoutes(
	item: Collection | ScreenSection,
	linkedType: MapRoute.LinkedTypeEnum,
	language: string,
	accountId?: number,
): SagaIterator {
	const platform = getConfiguration().getPlatform()
	const deviceUUID = getConfiguration().getDeviceUUID()
	const linkedId = item.id!
	const mapRoutes = item.map_routes
	const state = store.getState()
	const projectId = state.settings.appInfo.projectId

	if (mapRoutes) {
		for (const mapRoute of mapRoutes) {
			const mapRouteId = mapRoute.id!
			const mapRouteVersion = mapRoute.version!
			// check if exists on Disk
			const mapRouteFromDisk: any[] | undefined = yield call(
				getConfiguration().loadMapRouteFromDisk,
				projectId,
				mapRouteId,
				mapRouteVersion,
				language,
			)
			if (mapRouteFromDisk) {
				// store onto redux state
				yield put(
					loadedMapRouteFromDisk({
						linkedId,
						linkedType,
						mapRouteId,
						mapRouteVersion,
						mapRoute: mapRouteFromDisk,
						language,
					}),
				)
			} else {
				// else pull down json from network
				// send the async action to start the network request
				const params: MapRouteRequestParams = {
					devicePlatform: platform,
					deviceUdid: deviceUUID,
					linkedId,
					linkedType,
					mapRouteId,
					mapRouteVersion,
					language,
					accountId,
				}
				yield put(fetchMapRoute.started(params))
			}
		}
	}
}

function* handleLoadMapRoutesFromNetworkResult(action: LoadMapRoutesParams): SagaIterator {
	yield call(handleLoadMapRoutes, action.payload.item, action.payload.linkedType, action.payload.language, action.payload.accountId)
}

function* handleLoadedMapRouteFromNetwork(action: LoadMapRouteFromNetworkResult): SagaIterator {
	const { mapRouteId, mapRouteVersion, language } = action.payload.params
	const mapRoute: any = action.payload.result
	const state = store.getState()
	const projectId = state.settings.appInfo.projectId

	// first delete any old map route versions from disk
	try {
		yield call(getConfiguration().removeMapRouteFromDisk, projectId, mapRouteId, language)
	} catch (error) {
		// Error deleting old data
	}

	try {
		yield call(getConfiguration().saveMapRouteToDisk, projectId, mapRouteId, mapRouteVersion, language, mapRoute)
	} catch (error) {
		// Error saving data
	}
}

export default function*(): SagaIterator {
	yield takeEvery(loadMapRoutes, handleLoadMapRoutesFromNetworkResult)
	yield takeEvery(fetchMapRoute.done, handleLoadedMapRouteFromNetwork)
}
